import { Box, Tooltip, Typography } from "@mui/material";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { iresoftColors } from "../../../theme/ireColors";

interface PlacesCounterProps {
  count: number;
}

const PlacesCounter: React.FC<PlacesCounterProps> = ({ count }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 20,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        bgcolor: "rgba(255, 255, 255, 0.85)",
        padding: 2,
        borderRadius: 4,
        boxShadow: 4,
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        gap: 0.7,
      }}
    >
      <Tooltip arrow title={t("pages.welcome.tooltipIrebook")}>
        <Box
          component="img"
          src="../imgs/irebook.png"
          alt="Icon"
          sx={{
            width: 30,
            height: 30,
            filter: "drop-shadow(2px 4px 6px rgba(0,0,0,0.6))",
            transition: "transform 0.3s ease",
            opacity: 0.9,
            "&:hover": {
              transform: "scale(1.07)",
              cursor: "pointer",
            },
          }}
          onClick={() =>
            window.open("https://www.iresoft.cz/irebook", "_blank")
          }
        />
      </Tooltip>
      <Typography variant="h3" fontWeight="bold" sx={{ px: 1 }}>
        <Trans
          i18nKey="pages.welcome.visitedPlaces"
          values={{
            count: count,
            places:
              count === 1
                ? "místo"
                : count >= 2 && count <= 4
                ? "místa"
                : "míst",
          }}
          components={{
            red: (
              <span
                style={{ color: iresoftColors.iresoftRed, fontWeight: "bold" }}
              />
            ),
          }}
        />
      </Typography>
    </Box>
  );
};

export default PlacesCounter;
